import React from "react";
import { Nav, NavBar, MobileIcon, NavMenu } from "./styles.js";
import logoImg from "../../assets/images/saudedotrabalhador009.svg";
import { FiMenu } from "react-icons/fi";
import { NavLink } from "./NavLink";

export default function Navbar() {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Nav>
      <NavBar>
        <img src={logoImg} alt="Saúde do Trabalhador e a Covid-19" />
        <MobileIcon onClick={handleClick}>
          <FiMenu size={20} color={"#071242"} />
        </MobileIcon>
        <NavMenu status={isOpen}>
          <NavLink rota={{ pathname: "/" }} onClick={handleClick}>
            Início
          </NavLink>
          <NavLink rota={{ pathname: "/paineis" }} onClick={handleClick}>
            Painéis
          </NavLink>
          <NavLink rota={{ pathname: "/noticias" }} onClick={handleClick}>
            Notícias
          </NavLink>
          <NavLink rota={{ pathname: "/pesquisas" }} onClick={handleClick}>
            Pesquisas
          </NavLink>
        </NavMenu>
      </NavBar>
    </Nav>
  );
}
